export const ORGANIZATION_UNITS_RESET_STATE = 'ORGANIZATION_UNITS_RESET_STATE';
export const ORGANIZATION_UNITS_CURRENT_ITEM = 'ORGANIZATION_UNITS_CURRENT_ITEM';
 
export const ORGANIZATION_UNITS_REQUEST_LOADING = 'ORGANIZATION_UNITS_REQUEST_LOADING';
export const ORGANIZATION_UNITS_REQUEST_SUCCESS = 'ORGANIZATION_UNITS_REQUEST_SUCCESS';
export const ORGANIZATION_UNITS_REQUEST_FAILED = 'ORGANIZATION_UNITS_REQUEST_FAILED';
 
export const ORGANIZATION_UNITS_CURRENT_ACTION = 'ORGANIZATION_UNITS_CURRENT_ACTION';
export const ORGANIZATION_UNITS_RESET_ACTION = 'ORGANIZATION_UNITS_RESET_ACTION';